import { FC } from "react";
import { Dialog, Stack, Text } from "@chakra-ui/react";

import { CaseDocumentModel } from "@shared/models";

import CaseDocumentProgressBar from "../CaseDocumentProgressBar";
import { getParsingProgress } from "../CaseDocuments.utils";
import { CaseDocumentFileRow, CaseDocumentModalHeader } from "../CaseDocumentModal";

interface CaseNotesParsingStepProps {
  title: string;
  subtitle: string;
  caseDocument: CaseDocumentModel;
}

const CaseNotesParsingStep: FC<CaseNotesParsingStepProps> = ({ title, subtitle, caseDocument }) => (
  <>
    <CaseDocumentModalHeader title={title} subtitle={subtitle} />
    <Dialog.Body pb={8}>
      <Stack gap={3}>
        {caseDocument.files.map((file) => (
          <CaseDocumentFileRow key={file.id} file={file}>
            <Text flexShrink={0} fontSize="13px" color="brand.emptyStateText">
              Extracting text… {getParsingProgress(caseDocument)}%
            </Text>
          </CaseDocumentFileRow>
        ))}
        <CaseDocumentProgressBar value={getParsingProgress(caseDocument)} />
      </Stack>
    </Dialog.Body>
  </>
);

export default CaseNotesParsingStep;
